export const profileFormName = 'signup-profile-data';
export const newTeamMemberFormName = 'signup-team-member';

export const sizesAbbreviation = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
